import React from 'react';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';
import XinerLinkFlowsLogo from '../assets/flow2.png';

function Navbar() {
  const { currentUser } = useAuth();

  const handleProfileClick = (e) => {
    // Solo si hay algún indicador de inicio de sesión reciente, lo eliminamos
    // para evitar problemas con la navegación
    if (sessionStorage.getItem('justLoggedIn')) {
      sessionStorage.removeItem('justLoggedIn');
    }
    // Permitir que la navegación continúe normalmente
  };
  
  return (
    <nav className="app-navbar">
      <div className="navbar-left">
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <img src={XinerLinkFlowsLogo} alt="XinerLinkFlows" className="logo-image" />
          </Link>
        </div>
      </div>

      <div className="navbar-center">
        {/* El dropdown de workspaces se ha eliminado de aquí */}
      </div>

      <div className="navbar-right">
        {currentUser ? (
          <>
            <Link to="/profile" className="profile-link" onClick={handleProfileClick}>
              {currentUser.photoURL ? (
                <img 
                  src={currentUser.photoURL} 
                  alt="Profile" 
                  className="profile-avatar" 
                />
              ) : (
                <div className="profile-avatar-placeholder">
                  {currentUser.displayName ? currentUser.displayName.charAt(0) : "U"}
                </div>
              )}
            </Link>
          </>
        ) : (
          <Link to="/" className="login-link">Sign In</Link>
        )}
      </div>
    </nav>
  );
}

export default Navbar; 